import { Component, HostListener, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, isDevMode, ContentChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute, ActivationEnd, ActivationStart } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { DetectDeviceService } from './system/services/detect-device.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { HandlerService } from './system/error-handler/utilities/handler';
import { LocaleService } from './system/services/locale.service';
import { AppInitializerService } from './app-initializer.service';
import { MatSidenav } from '@angular/material/sidenav';
import { NotificationService } from './system/error-handler/notification/notification.service';
import { PopupComponent } from './components/popup/popup.component';
import { onMainContentChange } from './system/animations/side-nav-slide.animate';
import { GlobalFunctionService } from './system/services/global-function.service';
import { BaseService } from './system/services/base.service';
import { ResourceDetailComponent } from './modules/resource/resource-detail/resource-detail.component';
import { CacheService } from './system/services/cache.service';
import { SwPush } from '@angular/service-worker';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { ServiceWorkerService } from './system/services/service-worker.service';
import { forkJoin } from 'rxjs';
import { ApiService as AuthApiService } from '@app/modules/auth/utilities/services/api.service';
import { CacheBusterService } from './system/services/cacheBuster.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [onMainContentChange]
})
export class AppComponent implements OnInit, AfterViewInit {

	@ViewChild('sidenav') sidenav: MatSidenav;

	mode = 'default';
	title = 'unify';
	isLogin = false;
	onSideNavChange = false;
	loader = false;
	scrollState = false;
	lastUrl: string;
	localeChanges = false;
	resolutionTimeout = null;
	menuGroups: any = [];
	menuActivated = false;
	expire = 2000;
	isMenuActive = false;
	setupScreen = false;
	sideBarState = false;
	isDev = isDevMode();
	setLoginSubscribe;

	constructor(
		public gfService: GlobalFunctionService,
		public detectDevice: DetectDeviceService,
		private appInit: AppInitializerService,
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer,
		private router: Router,
		private el: ElementRef,
		public popup: MatDialog,
		private route: ActivatedRoute,
		private handlerService: HandlerService,
		public locale: LocaleService,
		private notificationService: NotificationService,
		private cdref: ChangeDetectorRef,
		private SW: ServiceWorkerService,
		private baseService: BaseService,
		private CC: CacheService,
		private swPush: SwPush,
		private globalApiService: GlobalApiService,
		private activatedRoute: ActivatedRoute,
		private authApiService: AuthApiService,
		private cacheBuster: CacheBusterService
	) {
		// this.CC.clearAllCache(false);
		// this.SW.checkForAppUpdate();
		if (!this.isDev) {
			this.cacheBuster.checkForAppUpdate();
		}
		iconRegistry.addSvgIcon('channels', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/channels.svg'));
		iconRegistry.addSvgIcon('badge', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/badge.svg'));
		iconRegistry.addSvgIcon('reassign', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/reassign.svg'));
		iconRegistry.addSvgIcon('workgroup', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/workgroup.svg'));
		iconRegistry.addSvgIcon('success', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/success.svg'));
		iconRegistry.addSvgIcon('warning', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/warning.svg'));
		iconRegistry.addSvgIcon('learning', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/learning.svg'));
		iconRegistry.addSvgIcon(
			'learning-path',
			sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/learning-path.svg')
		);
		iconRegistry.addSvgIcon('create', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/create.svg'));
		iconRegistry.addSvgIcon(
			'contribution',
			sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/contribution.svg')
		);
		iconRegistry.addSvgIcon(
			'notification',
			sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/notification.svg')
		);
		iconRegistry.addSvgIcon('resource', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/resource.svg'));
		iconRegistry.addSvgIcon('shield', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/shield.svg'));
		iconRegistry.addSvgIcon('role', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/role.svg'));
		iconRegistry.addSvgIcon('like', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/like.svg'));

		iconRegistry.addSvgIcon('video_camera', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/video-camera.svg'));
		iconRegistry.addSvgIcon('audio_headphone', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/audio-headphone.svg'));
		iconRegistry.addSvgIcon('pages', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/pages.svg'));
		iconRegistry.addSvgIcon('external_link', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/external-link.svg'));
		iconRegistry.addSvgIcon('document', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/document.svg'));
		iconRegistry.addSvgIcon('back', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/back.svg'));
		iconRegistry.addSvgIcon('next', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/next.svg'));
		// iconRegistry.addSvgIcon('cap', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/cap.svg'));
		iconRegistry.addSvgIcon('skill', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/skill.svg'));
		iconRegistry.addSvgIcon('bookmark', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/bookmark.svg'));
		iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/delete.svg'));
		iconRegistry.addSvgIcon('moderation', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/moderation.svg'));
		iconRegistry.addSvgIcon('assignment', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/assignment.svg'));
		iconRegistry.addSvgIcon('question_and_answer', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/question-and-answer.svg'));
		iconRegistry.addSvgIcon('course', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/course.svg'));
		iconRegistry.addSvgIcon('events', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/events.svg'));
		iconRegistry.addSvgIcon('knowledge_card', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/knowledge-card.svg'));
		iconRegistry.addSvgIcon('unifi_logo', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/unifi-logo.svg'));
		iconRegistry.addSvgIcon('comments', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/comments.svg'));
		iconRegistry.addSvgIcon('upload_icon', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/upload-icon.svg'));
		iconRegistry.addSvgIcon('admin', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/admin.svg'));
		iconRegistry.addSvgIcon('certificate', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/certificate.svg'));
		iconRegistry.addSvgIcon('forward_content', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/forward-content.svg'));
		iconRegistry.addSvgIcon('user-profile', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/user-profile.svg'));
		iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/edit.svg'));
		iconRegistry.addSvgIcon('past-reporting', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/past-reporting.svg'));
		iconRegistry.addSvgIcon('post', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/post.svg'));
		iconRegistry.addSvgIcon('playlist', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/playlist.svg'));
		iconRegistry.addSvgIcon('star-badge', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/star-badge.svg'));
		iconRegistry.addSvgIcon('shield-new', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/shield-new.svg'));
		iconRegistry.addSvgIcon('star-badge-outline', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/star-badge-outline.svg'));
		iconRegistry.addSvgIcon('arrow-down', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/arrow-down.svg'));
		iconRegistry.addSvgIcon('arrow-up', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/arrow-up.svg'));
		iconRegistry.addSvgIcon('youtube', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/youtube.svg'));
		iconRegistry.addSvgIcon('linkedin', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/linkedin.svg'));
		iconRegistry.addSvgIcon('next-arrow', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/next-arrow.svg'));
		iconRegistry.addSvgIcon('forward_outline', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/forward-outline.svg'));
		iconRegistry.addSvgIcon('bookmark_outline', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/bookmark-outline.svg'));
		iconRegistry.addSvgIcon('playlist_plus', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/playlist-plus.svg'));
		iconRegistry.addSvgIcon('drag_and_drop', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/drag-and-drop.svg'));
		iconRegistry.addSvgIcon('copy_url', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/copy-url.svg'));
		iconRegistry.addSvgIcon('image_collection', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/image-collection.svg'));
		iconRegistry.addSvgIcon('tick_mark', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/tick-mark.svg'));
		iconRegistry.addSvgIcon('bility_logo', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/bility-logo.svg'));
		iconRegistry.addSvgIcon('sad_emoji', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/sad-emoji.svg'));
		iconRegistry.addSvgIcon('bility_logo_tm', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/bility-logo-tm.svg'));
		iconRegistry.addSvgIcon('sorry', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/sorry.svg'));
		iconRegistry.addSvgIcon('oops', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/oops.svg'));
		iconRegistry.addSvgIcon('playlist_small', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/playlist-small.svg'));
		iconRegistry.addSvgIcon('register_learning', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/register-learning.svg'));
		iconRegistry.addSvgIcon('assessment', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/assessment.svg'));
		iconRegistry.addSvgIcon('people', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/people.svg'));
		iconRegistry.addSvgIcon('google_logo', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/google-logo.svg'));
		iconRegistry.addSvgIcon('engagement', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/engagement.svg'));
		iconRegistry.addSvgIcon('microsoft_logo', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/microsoft-logo.svg'));
		iconRegistry.addSvgIcon('error', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/error.svg'));
		iconRegistry.addSvgIcon('scorm', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/scorm.svg'));
		iconRegistry.addSvgIcon('lock', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/lock.svg'))	

		this.gfService.sessionUser = this.appInit.sessionUser;
		this.gfService.setTitle();
		this.detectDevice.resolution();
		this.gfService.globalBS$.subscribe((res) => {
			if (res) {
				if (res.type === 'MAIN') {
					this.sideBarState = res.state;
				} else if (res.type === 'BURGER') {
					this.onSideNavChange = res.state;
					if (this.sidenav)
						this.sidenav.toggle();
				} else if (res.type === 'PAGE_LOADER') {
					this.loader = res.loader;
				} else if (res.type === 'IS_LOGIN') {
					this.isLogin = res.isLogin;
				} else if (res.type === 'MODULE_NAME') {
					this.gfService.moduleName = res.name;
				}
			}
		});
		if (this.gfService.isLogin && location.hash && location.hash.match(/(home | auth)/)) {
			this.gfService.routeNavigation(`home`);
		}
		this.gfService.globalBS$.next({
			type: 'IS_LOGIN',
			isLogin: this.gfService.isLogin
		});
		this.gfService.loginState.next(this.gfService.isLogin);
		router.events.forEach((event) => {
			if (event instanceof NavigationStart) {
				this.handlerService.cancelPendingRequests$.next();
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: true
					}
				);
				// console.log('NavigationStart');
			}
			if (event instanceof NavigationEnd) {
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: false
					}
				);
				const url = router.parseUrl(router.url).root.children['primary'].segments[0].path;
				if (url === 'setup') {
					this.setupScreen = true;
				} else {
					this.setupScreen = false;
				}
				if (!this.lastUrl || this.lastUrl !== url) {
					const target = this.el.nativeElement.querySelector('#scrollReset');
					if (target != null) {
						target.scrollIntoView({
							behavior: 'instant',
							block: 'end',
							inline: 'nearest'
						});
					}
				}
				this.lastUrl = url;
				this.menuActivated = false;
				// this.gfService.blockHttpCall = true;
				// console.log('NavigationEnd');
				// this.handlerService.cancelPendingRequests$.next();
			}
			if (event instanceof NavigationCancel) {
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: false
					}
				);
				// console.log('NavigationCancel');
			}
			if (event instanceof NavigationError) {
				console.log('error', event);
				console.log('error ChunkLoadError', event.error.name === 'ChunkLoadError');
				if (event.error && (event.error.name === 'ChunkLoadError' || event.error.message.includes(`'call' of undefined`))) {
					console.log('error under if condition', event);
					window.location.reload();
				}
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: false
					}
				);
				// console.log('NavigationError');
			}
		});
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(() => this.route),
			map(route => {
				while (route.firstChild) route = route.firstChild
				return route
			}),
			filter(route => route.outlet === 'primary'),
			mergeMap(route => route.data)
		).subscribe(data => {
			if (data) {
				if (data.hasOwnProperty('componentName')) {
					this.gfService.globalBS$.next(
						{
							type: 'MODULE_NAME',
							name: data.componentName
						}
					);
				} else {
					this.gfService.globalBS$.next(
						{
							type: 'MODULE_NAME',
							name: data.moduleName
						}
					);
				}
			}
		});
		this.processQueryParams();
	}

	processQueryParams() {
		if (navigator.onLine) {
			this.route.queryParamMap.subscribe(params => {
				const trigger = params.get('trigger');
				if (trigger) {
					if (trigger === 'resource') {
						const resourceID = Number(params.get('resourceID'));
						const popup = params.get('popup');
						const type = params.get('type');
						if (resourceID && popup) {
							setTimeout(() => {
								this.loadResource(type);
							});
						}
					}
				}
			});
		}
	}

	loadResource(type = null) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceDetailComponent,
				componentData: [
					{
						variableName: 'type',
						value: type
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%',
			// closeOnNavigation: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
				const queryParams = {
					popup: null,
					resourceID: null,
					assignmentID: null,
					trigger: null,
					type: null
				};
				this.router.navigate([], {
					relativeTo: this.route,
					queryParamsHandling: 'merge',
					queryParams
				});
			}
		});
	}

	ngOnInit() {
		// const menu = [
		// 	{

		// 		"key": "",
		// 		"title": "",
		// 		"svgIcon": "resource",
		// 		"icon": "",
		// 		"isVisible": false,
		// 		"menuList": [
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 1
		// 			},
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "last",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 1
		// 			},
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 2
		// 			},
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "last",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 2
		// 			},
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 3
		// 			},
		// 			{
		// 				"key": "knowledgeBeads",
		// 				"active": "",
		// 				"title": "last",
		// 				"link": "/knowledge-bead",
		// 				"order": 1,
		// 				"moduleName": "KnowledgeBeadModule",
		// 				"matchQueryParams": [],
		// 				"queryParams": {
		// 					"tab": "for_me"
		// 				},
		// 				"svgIcon": "",
		// 				"icon": "",
		// 				"predefined": false,
		// 				"groupOrder": 1
		// 			}
		// 		]
		// 	}
		// ];
		// for (const data of menu) {
		// 	data.menuList = data.menuList.sort((a, b) => {
		// 		return a.groupOrder - b.groupOrder;
		// 	});
		// }
		// menu.map((data, index) => {
		// 	data.menuList = data.menuList.sort((a, b) => {
		// 		return a.groupOrder - b.groupOrder;
		// 	});
		// 	let lastOrder = null;
		// 	for (const child of data.menuList) {
		// 		if (lastOrder !== child.groupOrder) {
		// 			const matchedData = menu[index].menuList.filter(items => items.groupOrder === child.groupOrder);
		// 			if (matchedData && matchedData.length) {
		// 				matchedData[matchedData.length - 1]['isLast'] = true;
		// 				lastOrder = child.groupOrder;
		// 			}
		// 		}
		// 	}
		// });
		// console.log(menu);
		this.SW.updateApp();
		this.checkConnectionStatus();
		this.locale.localeChangeDetect.subscribe(resp => {
			this.localeChanges = resp;
			if (!this.localeChanges) {
				this.getMenuObject();
				this.cdref.detectChanges();
				this.onSideNavChange = false;
				this.menuActivated = false;
				this.ngAfterViewInit();
			}
		});
		this.gfService.loginState.subscribe(resp => {
			if (resp) {
				this.getMenuObject();
			} else {
				this.menuGroups = [];
			}
		});
		this.baseService.menuUpdate.subscribe(resp => {
			if (resp) {
				this.sidenav.close();
				this.getMenuObject();
			}
		});
		this.SW.updateAvailable.subscribe(resp => {
			if (resp) {
				if (document.visibilityState === 'hidden') {
					this.SW.activateUpdate();
				} else {
					this.updateApplication();
				}
			}
		});
		document.addEventListener('visibilitychange', () => {
			// console.log(document.hidden, document.visibilityState);
			if (document.visibilityState === 'hidden' && this.isLogin) {
				this.setLoginData();
			}
		});
	}

	updateApplication() {
		if (navigator.onLine) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				maxWidth: '460px',
				minHeight: '200px',
				data: {
					action: 'updateApplication'
				},
				disableClose: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result && result === 'update') {
					this.SW.activateUpdate();
				}
			});
		}
	}

	@HostListener('window:beforeunload', ['$event'])
	unloadNotification($event: any) {
		if (this.baseService.formView && !this.isDev) {
			$event.returnValue = true;
		}
	}

	ngAfterViewInit() {
		if (this.sidenav) {
			this.sidenav.closedStart.subscribe(resp => {
				this.onSideNavChange = false;
			});
			this.sidenav.openedStart.subscribe(resp => {
				if (!this.menuActivated) {
					this.setMenuActive();
				}
			});
			// setTimeout(() => {
			// 	this.SW.requestPushNotification();
			// }, 1000);
			this.gfService.globalBS$.subscribe((res) => {
				if (res) {
					if (res.type === 'NOTIFICATION_PERMISSION') {
						setTimeout(() => {
							this.SW.requestPushNotification();
						}, 1000);
					}
				}
			});
		}
	}

	setLoginData() {
		if (!this.setLoginSubscribe || (this.setLoginSubscribe && this.setLoginSubscribe['closed'])) {
			const sessionUserApiData = {};
			const sessionUserHeaders = {};
			const menuHeaders = {};
			const weightageApiData = {
				termsetid: 2
			};
			const weightageHeaders: any = {};
			const menuParams: any = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			const roleApiData = {};
			const roleHeaders: any = {};
			const apiCallArr = [
				this.authApiService.sessionUser(sessionUserApiData, sessionUserHeaders),
				this.globalApiService.getTerm(weightageApiData, weightageHeaders),
				this.globalApiService.getMenu(menuParams, menuHeaders),
				this.authApiService.getRolePermission(roleApiData, roleHeaders),
				this.globalApiService.getResourceTypes(roleApiData, roleHeaders)
			];
			this.setLoginSubscribe = forkJoin(apiCallArr).subscribe(
				(innerResponse) => {
					if (innerResponse.length === 5) {
						if (innerResponse[0]) {
							this.gfService.sessionUser = innerResponse[0];
							if (this.gfService.sessionUser.profile) {
								this.gfService.sessionUser.name = `${this.gfService.sessionUser.profile.firstName}${this.gfService.sessionUser.profile.lastName
									? ' ' + this.gfService.sessionUser.profile.lastName
									: ''}`;
							}
						}
						if (innerResponse[1] && this.gfService.sessionUser) {
							this.gfService.sessionUser.weightageData = innerResponse[1].records;
						}

						if (innerResponse[2] && this.gfService.sessionUser) {
							this.gfService.sessionUser.menuData = innerResponse[2];
						}
						if (innerResponse[3] && this.gfService.sessionUser) {
							if (innerResponse[3].records && innerResponse[3].records.length) {
								let permissions = [];
								for (const data of innerResponse[3].records) {
									permissions = permissions.concat(data.functionIDs);
								}
								this.gfService.sessionUser.permissions = permissions;
							}
							if (innerResponse[3].modulesAvailable && innerResponse[3].modulesAvailable.length){
								let modulesAvailable = innerResponse[3].modulesAvailable;
								this.gfService.sessionUser.modulesAvailable = modulesAvailable;
							}
						}
						if (innerResponse[4] && this.gfService.sessionUser) {
							if (this.gfService.sessionUser.resourceTypes) {
								delete this.gfService.sessionUser.resourceTypes;
							}
							this.gfService.sessionUser.tempResourceTypes = innerResponse[4].records;
						}
						this.cdref.detectChanges();
						this.baseService.menuUpdate.next(true);
					}
				},
				(error) => {
					// this.gfService.errorHandler(error, {
					// 	snackBar: {
					// 		position: 'before'
					// 	}
					// });
				}
			)
				.add(() => {
				});
		}
	}

	getMenuObject() {
		if (this.gfService.sessionUser && this.gfService.sessionUser.menuData) {
			if (this.gfService.sessionUser.menuData.menu.length) {
				this.menuGroups = JSON.parse(JSON.stringify(this.gfService.sessionUser.menuData.menu));
			}
		}
	}

	showChildMenu(action: 'click' | 'hover', menu) {
		for (let i = 0; i < this.menuGroups.length; i++) {
			this.menuGroups[i].active = false;
		}
		menu.active = true;
		this.isMenuActive = true;
		this.menuActivated = false;
		if (action === 'click' && this.detectDevice.resolutionState$.value.deviceType === 'desktop') {
			if (!menu.refMenu) {
				this.routerNav(menu);
			} else {
				const refMenu = menu.menuList.find(items => items.key === menu.refMenu);
				if (refMenu) {
					this.routerNav(refMenu);
				}
			}
		}
	}

	setMenuActive() {
		this.isMenuActive = false;
		const actualURL = this.router.url.split('?')[0];
		const queryParams = this.router.parseUrl(this.router.url).queryParams;
		for (let i = 0; i < this.menuGroups.length; i++) {
			// for (let j = 0; j < this.menuGroups[i].menuList.length; j++) {
			this.menuGroups[i].active = false;
			// }
		}
		for (let i = 0; i < this.menuGroups.length; i++) {
			// this.menuGroups[i].active = false;

			if (this.menuGroups[i].menuList && this.menuGroups[i].menuList.length) {
				for (let j = 0; j < this.menuGroups[i].menuList.length; j++) {
					if (this.menuGroups[i].menuList[j].link === actualURL && actualURL !== '/home') {
						if (queryParams && this.menuGroups[i].menuList[j].moduleName === 'Resource') {
							if (queryParams.resourceType) {
								if (queryParams.resourceType === this.menuGroups[i].menuList[j].queryParams.resourceType) {
									this.isMenuActive = true;
									this.menuGroups[i].active = true;
									break;
								}
							} else if (!this.menuGroups[i].menuList[j].queryParams || !this.menuGroups[i].menuList[j].queryParams.resourceType) {
								this.isMenuActive = true;
								this.menuGroups[i].active = true;
								break;
							}
						} else {
							this.menuGroups[i].active = true;
							this.isMenuActive = true;
							break;
						}
					}
				}
			} else {
				if (this.menuGroups[i].link === actualURL && actualURL !== '/home') {
					this.menuGroups[i].active = true;
					this.isMenuActive = true;
				}

			}
			if (this.isMenuActive) {
				break;
			}
		}
		if (!this.isMenuActive) {
			this.menuGroups[0].active = true;
			this.isMenuActive = true;
		}
		this.menuActivated = true;
	}

	routerNav(menu) {
		if (navigator.onLine) {
			if (menu && menu.link) {
				this.menuActivated = false;
				this.sidenav.toggle();
				if (menu.key === 'bookmarks') {
					this.bookmarkDetail();
				} else {
					if (menu.key === 'userEndorsement' || menu.key === 'skillEndorsement') {
						// this.gfService.blockHttpCall = false;
					}
					this.gfService.routeNavigation(menu.link, menu.queryParams);
				}
			}
		}
	}

	bookmarkDetail() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('./modules/resource/bookmarks/bookmarks.component'),
				componentData: []
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
		});
	}


	@HostListener('window:resize', ['$event'])
	onResize() {
		if (this.resolutionTimeout) {
			clearTimeout(this.resolutionTimeout);
		}
		this.resolutionTimeout = setTimeout(() => {
			this.detectDevice.resolution();
		}, 200);
	}

	@HostListener('click', ['$event.target'])
	onClickDOM(event) {
		if (!navigator.cookieEnabled) {
			// No Internet connection
			this.router.navigate(['/cookie-blocked']);
		}
		if (!navigator.onLine) {
			this.popup.closeAll();
		}
		// if (!navigator.onLine) {
		// 	this.expire = 172800000;
		// 	this.notificationService.notify(this.locale.translate('you_are_offline'));
		// } else {
		// 	this.expire = 2000;
		// 	this.notificationService.clear();
		// }
		const allowedURL = ['auth/login', 'auth/verify-login', 'auth/register', 'auth/report'];
		const accessState = allowedURL.find((items) => this.router.url.includes(items));
		if ([null, undefined].includes(accessState)) {
			const isLogin = this.gfService.isLogin;
			this.gfService.globalBS$.next({
				type: 'IS_LOGIN',
				isLogin: isLogin
			});
			this.gfService.globalBS$.subscribe(resp => {
				if (resp && resp.type === 'IS_LOGIN') {
					this.isLogin = resp.isLogin;
				}
			});
			if (!isLogin) {
				if (this.popup.openDialogs.length) {
					this.popup.closeAll();
				}
				this.gfService.sessionUser = null;
				this.appInit.sessionUser = null;
				// localStorage.removeItem('profilePicture');
				// localStorage.removeItem('companyLogo');
				// this.gfService.globalBS$.next(
				// 	{
				// 		type: 'MODULE_NAME',
				// 		name: null
				// 	}
				// );
				this.gfService.routeNavigation('auth/login');
				// this.gfService.lastParentMenu = [];
			}
		}
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
	}

	checkConnectionStatus() {
		addEventListener('offline', () => {
			this.expire = 172800000;
			this.notificationService.notify(this.locale.translate('you_are_offline'));
		});
		addEventListener('online', () => {
			this.expire = 2000;
			this.notificationService.clear();
		});
	}

	onScroll(event) {
		this.gfService.globalS$.next(
			{
				type: 'WINDOW_SCROLL',
				data: event
			}
		);
		if (event.target.scrollTop > 200) {
			this.scrollState = true;
		} else {
			this.scrollState = false;
		}
	}

	goToTop() {
		const target = this.el.nativeElement.querySelector('#scrollReset');
		if (target != null) {
			target.scrollIntoView({
				behavior: 'smooth',
				block: 'end',
				inline: 'start'
			});
		}
	}
}
